export default __webpack_public_path__ + "static/media/rs.099fd9d4.svg";